module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.e1c83f9.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/OpenSans/OpenSans-SemiBold.ttf
// module id = 151
// module chunks = 245 246